import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './modules/auth/components/forgot-password/forgot-password.component';
import { LoginComponent } from './modules/auth/components/login/login.component';
import { ResetPasswordComponent } from './modules/auth/components/reset-password/reset-password.component';
import { AuthGuard } from './modules/auth/guards/auth.guard';
import { OpenToolRegisteredGuard } from './modules/auth/guards/open-tool-registered.guard';
import { OpenToolGuard } from './modules/auth/guards/open-tool.guard';
import { MainComponent } from './modules/main/components/main/main.component';
import { SizeOfThePrize } from './modules/main/components/size-of-the-prize/size-of-the-prize.component';
import { SampleAppComponent } from './modules/sample-app/components/sample-app.component';
import { FreemiumRegisterComponent } from './modules/main/components/freemium-register/freemium-register.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'size-of-prize',
    component: SizeOfThePrize,
    canActivate: [AuthGuard],
  },
  {
    path: 'freemium/register',
    component: FreemiumRegisterComponent,
  },
  {
    path: 'sample',
    component: SampleAppComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/user-admin/user-admin.module').then(
        (m) => m.UserAdminModule
      ),
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgotten-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
